/* eslint-disable no-throw-literal */
import { GROUP_ENDPOINT, PATCH_USER_PROFILE_ENDPOINT, PHYSICIANS_ENDPOINT } from "../config/api-endpoints"
import { authorizeHeader } from "../utils/auth-header"



export const getPhysicianCall = async (organizationID) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = PHYSICIANS_ENDPOINT + "organization/fc376328-1939-47a8-94b7-153b68b7970d/physicians/"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw Error(`Response is not a JSON.`);
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e)
  }
}


export const getSingleGroupAPICall = async (groupId) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await window.fetch(GROUP_ENDPOINT + '/' + encodeURIComponent(groupId), authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const postCreateGroupAPICall = async (payload) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
    const response = await window.fetch(GROUP_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}



export const getCheckGroupAPICall = async () => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await window.fetch(GROUP_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const postCreatePhysiciansCall = async ({ name, email, phone_number, primary_facility, specialty, organizationGuid, invitedByOrganization }) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        full_name: name,
        email,
        phone_number,
        primary_facility: primary_facility?.length ? {name: primary_facility[0], guid: primary_facility[1]}: undefined,
        specialty: specialty?.length ? specialty[0] : undefined,
        organization_guid: organizationGuid,
        invited_by_organization: invitedByOrganization
      })
    }
    const endpointToHit = PHYSICIANS_ENDPOINT + "physicians/"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}



export const patchUserProfileApiCall = async (userId, requestBody) => {
  try {
    const config = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const response = await window.fetch(PATCH_USER_PROFILE_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const patchAffiliatedGroupAPICall = async ({ affiliatedGroupGuid, sourceGroupGuid }) => {
  try {
    const config = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ available_to: sourceGroupGuid })
    }

    const groupId = affiliatedGroupGuid ? affiliatedGroupGuid : sourceGroupGuid
    const response = await window.fetch(GROUP_ENDPOINT + '/' + encodeURIComponent(groupId), authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const getExternalPhysiciansCall = async (organizationID) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = PHYSICIANS_ENDPOINT + "organization/" + organizationID + "/external-physicians/"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const getInternalPhysiciansCall = async (organizationID) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = PHYSICIANS_ENDPOINT + "organization/" + organizationID + "/physicians/"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}